module.exports = "<div class=\"input-container\">\n  <label for=\"{{$ctrl.prefix}}complementInput\">Complément</label>\n  <input type=\"text\" name=\"{{$ctrl.prefix}}complement\" id=\"{{$ctrl.prefix}}complementInput\" ng-model=\"$ctrl.data.complement\" ng-change=\"$ctrl.onChange()\" maxlength=\"150\" class=\"input-text-400\">\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/components/complement-adresse/complement-adresse.html
// module id = 303
// module chunks = 0